export default __webpack_public_path__ + "10ae99e458ca8a734b1d0c3cf4011e78.svg";